import React from 'react';

import Tag from '../Tag';
import {
    AttentionTagProps,
    ErrorTagProps,
    ExternalLinkTagProps as ExLinkTagProps,
    InfoTagProps,
    InvertedTagProps,
    PendingTagProps,
    SuccessTagProps,
    WarningTagProps,
    BaseTagProps,
} from '../types';

export const AttentionTag = ({ ...rest }: Omit<AttentionTagProps, 'type'>) => <Tag type="attention" {...rest} />;
export const DefaultTag = ({ ...rest }: Omit<BaseTagProps, 'type'>) => <Tag type="default" {...rest} />;
export const ErrorTag = ({ ...rest }: Omit<ErrorTagProps, 'type'>) => <Tag type="error" {...rest} />;
export const ExternalLinkTag = ({ ...rest }: Omit<ExLinkTagProps, 'type'>) => <Tag type="external-link" {...rest} />;
export const InfoTag = ({ ...rest }: Omit<InfoTagProps, 'type'>) => <Tag type="info" {...rest} />;
export const InvertedTag = ({ ...rest }: Omit<InvertedTagProps, 'type'>) => <Tag type="inverted" {...rest} />;
export const PendingTag = ({ ...rest }: Omit<PendingTagProps, 'type'>) => <Tag type="pending" {...rest} />;
export const SuccessTag = ({ ...rest }: Omit<SuccessTagProps, 'type'>) => <Tag type="success" {...rest} />;
export const WarningTag = ({ ...rest }: Omit<WarningTagProps, 'type'>) => <Tag type="warning" {...rest} />;
